import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=75cbc1c3&"
import script from "./Accordion.vue?vue&type=script&lang=ts&"
export * from "./Accordion.vue?vue&type=script&lang=ts&"
import style0 from "./Accordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Disclosure: require('/tmp/build_71ad00c4/src/components/misc/Disclosure.vue').default,BlockWrapper: require('/tmp/build_71ad00c4/src/components/block/BlockWrapper.vue').default})
